import { Injectable } from '@angular/core';
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  registeredDialogs: MatDialogRef<any>[];

  constructor() {
    this.registeredDialogs = [];
  }

  RegisterDialog(newDialog: MatDialogRef<any>) {
    this.registeredDialogs.push(newDialog);
    // console.log("Registering new dialog");
  }

  DeRegisterDialog(newDialog: MatDialogRef<any>) : boolean {
    for (let i = 0; i < this.registeredDialogs.length; i++) {
      if (newDialog == this.registeredDialogs[i]) {
        // Found the specific dialog that should be deregistered.
        this.registeredDialogs.splice(i, 1);
        // console.log("Deregistering a dialog");
        return true;
      }
    }

    return false;
  }

  DeRegisterAll() {
    for (let i = 0; i < this.registeredDialogs.length; i++) {
      this.registeredDialogs[i].close();
    }
    this.registeredDialogs = [];
  }
}
